import RoleCreate from './RoleCreate';

export default RoleCreate;
